import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-6" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-6" }
const _hoisted_5 = { class: "col-lg-4 col-6" }
const _hoisted_6 = { class: "col-lg-4 col-6" }
const _hoisted_7 = { class: "col-lg-4 col-6" }
const _hoisted_8 = { class: "col-lg-4 col-6" }
const _hoisted_9 = { class: "col-lg-4 col-6" }
const _hoisted_10 = { class: "col-xxl-6" }
const _hoisted_11 = { class: "col-xxl-4 col-md-6" }
const _hoisted_12 = { class: "col-xxl-4 col-md-6" }
const _hoisted_13 = { class: "col-xxl-4 col-md-12" }
const _hoisted_14 = { class: "col-lg-8" }
const _hoisted_15 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InstagramFollowers = _resolveComponent("InstagramFollowers")!
  const _component_LinkedInFollowers = _resolveComponent("LinkedInFollowers")!
  const _component_TikTokFollowers = _resolveComponent("TikTokFollowers")!
  const _component_FacebookFollowers = _resolveComponent("FacebookFollowers")!
  const _component_XFollowers = _resolveComponent("XFollowers")!
  const _component_YouTubeSubscribers = _resolveComponent("YouTubeSubscribers")!
  const _component_LinkedInNetFollowersChart = _resolveComponent("LinkedInNetFollowersChart")!
  const _component_Suggestions = _resolveComponent("Suggestions")!
  const _component_FollowersByGenderChart = _resolveComponent("FollowersByGenderChart")!
  const _component_RecentInstagramFollowers = _resolveComponent("RecentInstagramFollowers")!
  const _component_FacebookCampaignOverviewChart = _resolveComponent("FacebookCampaignOverviewChart")!
  const _component_UpgradePlan = _resolveComponent("UpgradePlan")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_InstagramFollowers)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_LinkedInFollowers)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_TikTokFollowers)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_FacebookFollowers)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_XFollowers)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_YouTubeSubscribers)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_LinkedInNetFollowersChart)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_Suggestions)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_FollowersByGenderChart)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_RecentInstagramFollowers)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_FacebookCampaignOverviewChart)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_UpgradePlan)
    ])
  ]))
}